{
  "documentEditor": {
    "title": "Editor dokumentu",
    "loading": "Otevírání dokumentu…",
    "slowLoading": "Načítání editoru trvá déle. Můžete počkat nebo dokument znovu otevřít.",
    "unavailable": "Editor dokumentu je nedostupný. Zkuste dokument znovu otevřít.",
    "invalidSession": "Relaci dokumentu se nepodařilo ověřit. Otevřete dokument znovu.",
    "invalidDocument": "Tento dokument nelze otevřít v editoru.",
    "authenticationRequired": "Vaše přihlášení vypršelo. Přihlaste se znovu a otevřete dokument.",
    "forbidden": "Nemáte oprávnění otevřít dokument v tomto režimu.",
    "notFound": "Záznam nebo jeho příloha už nejsou dostupné.",
    "conflict": "Dokument je zamčený nebo se změnil jeho stav. Zkuste to později.",
    "disabled": "Úprava dokumentů není v tomto prostředí dostupná.",
    "saveFirst": "Před otevřením této přílohy v editoru uložte záznam.",
    "reopen": "Znovu otevřít dokument",
    "expired": "Relace vypršela. Ponechte editor otevřený, abyste mohli zkontrolovat svou práci. Novým otevřením můžete ztratit neuložené změny.",
    "expiring": "Relace vyprší za méně než pět minut. Dokončete svou práci v editoru.",
    "confirmTitle": "Opustit editor dokumentu?",
    "confirmLeave": "Změny se mohou ještě ukládat. Před odchodem nebo novým otevřením zkontrolujte stav uložení v editoru.",
    "actions": {
      "view": "Otevřít v OnlyOffice",
      "edit": "Upravit v OnlyOffice",
      "review": "Revidovat v OnlyOffice"
    },
    "modes": {
      "view": "Zobrazení",
      "edit": "Úprava",
      "review": "Revize"
    }
  },
  "overview": {
    "activities": "Přehled aktivít",
    "noDashboardData": "Nemáte žádná data pro přehled",
    "approvals": "Záznamy ke schválení",
    "text": "Přehled vaší agendy k <strong>{{date}}</strong>",
    "welcome": "Dobrý den, ",
    "agendaOverview": "Přehled agendy",
    "record": "Záznam",
    "newRecords": "Nové záznamy",
    "unfilled": "Nevyplněno",
    "favoriteAgendas": "Oblíbené agendy"
  },
  "comments": {
    "writeComment": "Napište komentář"
  },
  "modules": {
    "title": "Vaše moduly",
    "subTitle": "Označte hvězdičkou agendy, které chcete mít na přehledu.",
    "subTitleMobile": "Otevřete modul a označte hvězdičkou agendy pro přehled.",
    "showAll": "zobrazit vše",
    "childModules": "Podřízené moduly",
    "totalRecords": "Celkem záznamů",
    "waitingForApproval": "Čeká na schválení",
    "newest": "Nejnovější",
    "shareRecordTitle": "Sdílení záznamu"
  },
  "delete": {
    "success": "Záznam byl úspěšně smazán",
    "successMultiple_few": "{{count}} záznamy úspěšně smazány",
    "successMultiple_other": "{{count}} záznamů úspěšně smazáno",
    "error": "Při mazání záznamu se vyskytla chyba",
    "errorForbidden": "Nemáte oprávnění ke smazání tohoto záznamu",
    "errorMultiple_zero": "Při mazání záznamů se vyskytla chyba. Žádný záznam z {{total}} vybraných nebyl smazán",
    "errorMultiple_one": "Při mazání záznamů se vyskytla chyba. Byl smazán {{count}} záznam z {{total}} vybraných",
    "errorMultiple_few": "Při mazání záznamů se vyskytla chyba. Byly smazány {{count}} záznamy z {{total}} vybraných",
    "errorMultiple_other": "Při mazání záznamů se vyskytla chyba. Bylo smazáno {{count}} záznamů z {{total}} vybraných",
    "dirtyTableCannotDelete": "Nemůžete mazat záznamy, když je tabulka upravována. Uložte nebo zrušte své změny a zkuste to znovu.",
    "selectEntriesToDelete": "Nejprve vyberte záznamy, které chcete smazat"
  },
  "detail": {
    "titleNew": "Nový záznam",
    "titleEdit": "Úprava záznamu",
    "share": {
      "title": "Osoby ke sdílení",
      "add": "Přidat",
      "sharedTitle": "Osoby, se kterými je záznam sdílen",
      "backToShare": "Zpět ke sdílení",
      "showOverview": "Zobrazit přehled",
      "shareDateTime": "Datum a čas sdílení",
      "supplierSection": "Pozvat dodavatele",
      "supplierEmail": "E-mail dodavatele",
      "role": "Role",
      "allowForwarding": "Povolit přeposílání",
      "invite": "Odeslat pozvánku",
      "invitationSent": "Pozvánka byla odeslána na {{email}}",
      "viewer": "Prohlížeč",
      "approver": "Schvalovatel",
      "revoke": "Odebrat",
      "revoked": "Pozvánka byla odebrána"
    },
    "file": {
      "copyLink": "Kopírovat odkaz",
      "copyEditLink": "Kopírovat editační odkaz",
      "attachmentsTitle": "Přílohy",
      "filesCount_one": "{{count}} soubor",
      "filesCount_few": "{{count}} soubory",
      "filesCount_other": "{{count}} souborů",
      "maxFilesReached": "Lze nahrát maximálně {{max}} souborů",
      "onlySomeFilesUploaded": "Bylo nahráno pouze {{uploaded}} z {{total}} vybraných souborů (maximum: {{max}})",
      "maxFilesPerUpload": "Najednou lze nahrát maximálně {{maxFiles}} souborů.",
      "fileTooLarge": "Maximální velikost souboru je {{max}} MB.",
      "uploadInProgress": "Probíhá nahrávání. Počkejte na jeho dokončení.",
      "loadFailed": "Přílohy se nepodařilo načíst.",
      "uploadFailed": "Soubor '{{fileName}}' se nepodařilo nahrát.",
      "retry": "Zkusit znovu",
      "preview": {
        "notSupported": "Náhled není podporován",
        "failedToDisplay": "Nepodařilo se zobrazit náhled dokumentu.",
        "noData": "Soubor neobsahuje žádná data.",
        "readError": "Chyba čtení souboru."
      }
    },
    "form": {
      "title": "Chcete zavřít formulář?",
      "text": "Ve formuláři máte neuložené změny. Pokud jej zavřete, o tato data přijdete. Chcete formulář opravdu zavřít?",
      "noCreate": "V této agendě není povoleno vytváření záznamů"
    },
    "modal": {
      "changeBehaviorTitle": "Byla provedena změna záznamu",
      "saveNestedList": "V položkovém přehledu je neuložený záznam",
      "notifyUserToSave": "Pro správnou funkcionalitu formuláře je vhodné přeuložit záznam",
      "notifyUnsavedValues": "Formulář obsahuje hodnoty, které nebudou uloženy.",
      "saveRequired": "Pro správnou funkcionalitu formuláře je vyžadováno přeuložit záznam. Záznam bude přeuložen"
    },
    "lock": {
      "lockedTitle": "Záznam je uzamčen",
      "lockedMessage": "Tento záznam právě upravuje {{name}}. Zámek vyprší v {{expiresAt}}.",
      "viewRecord": "Zobrazit záznam",
      "expiredTitle": "Zámek úprav vypršel",
      "expiringTitle": "Zámek úprav brzy vyprší",
      "expiringMessage": "Platnost zámku záznamu brzy vyprší. Chcete pokračovat v úpravách?",
      "expiringCountdown": "Zámek vyprší za {{countdown}}",
      "continueEditing": "Pokračovat v úpravách",
      "stopEditing": "Ukončit úpravy",
      "expiredMessage": "Váš zámek úprav vypršel z důvodu neaktivity. Neuložené změny jsou ztraceny.",
      "ok": "OK",
      "activeIndicator": "Upravujete tento záznam",
      "conflictExpired": "Váš zámek úprav vypršel. Prosím, znovu otevřete režim úprav.",
      "editingBanner": "{{name}} právě upravuje tento záznam."
    },
    "deleteModal": {
      "title": "Smazat záznam",
      "titleMultiple": "Smazat záznamy",
      "text": "Opravdu chcete tento záznam smazat? Tato akce je nevratná.",
      "textMultiple_few": "Opravdu chcete {{count}} vybrané záznamy smazat? Tato akce je nevratná.",
      "textMultiple_other": "Opravdu chcete {{count}} vybraných záznamů smazat? Tato akce je nevratná."
    }
  },
  "contacts": {
    "title": "Rozdělovník",
    "table": {
      "export": "Exportovat",
      "print": "Tisk",
      "filters": "Filtry",
      "search": "Hledat"
    },
    "toast": {
      "groupUpdated": "Skupina byla úspěšně aktualizována",
      "groupShared": "Skupina byla úspěšně sdílena",
      "groupCreated": "Skupina byla úspěšně vytvořena",
      "groupDeleted": "Skupina byla úspěšně smazána",
      "groupAccepted": "Skupina byla úspěšně přijata"
    },
    "groups": {
      "_": "Skupiny",
      "title": "Skupiny",
      "create": "Vytvořit",
      "search": "Hledat ve skupině",
      "groupName": {
        "label": "Název nové skupiny",
        "placeholder": "Zadejte název skupiny"
      },
      "all": "Vše",
      "users": "Uživatelé",
      "usersToShare": "Osoby ke sdílení",
      "accept": "Přijmout",
      "remove": "Odebrat",
      "decline": "Odmítnout",
      "deleteConfirmTitle": "Opravdu chcete odebrat tuto skupinu?",
      "deleteConfirmDescription": "Tato akce je nevratná."
    },
    "contacts": {
      "person": "Osoba",
      "email": "Email",
      "phoneNumber": "Telefonní číslo",
      "organization": "Společnost / Pracovní pozice"
    },
    "add": "Přidat",
    "update": "Upravit",
    "share": "Sdílet"
  },
  "chat": {
    "assistantTitle": "Flowio asistent",
    "newChat": "Nový chat",
    "assistantLabel": "Asistent:",
    "youLabel": "Vy:",
    "modeLabel": "Režim ",
    "modeGuide": "Asistent",
    "modeGuideDescription": "Pomůže vám s obecnými dotazy a navigací v administraci ",
    "modeJson": "Šablon",
    "modeJsonDescription": "Pomůže vám generovat JSON šablony pro snadnější administraci",
    "thinking": "Asistent přemýšlí…",
    "thinkingAnalyzingDocs": "Přemýšlím nad vaším dotazem",
    "inputPlaceholder": "Napište zprávu…",
    "sendTitle": "Odeslat",
    "sendingTitle": "Odesílám…",
    "maximizeTitle": "Maximalizovat",
    "restoreTitle": "Obnovit velikost",
    "closeTitle": "Zavřít",
    "aiDisclaimer": "AI asistent může dělat chyby. Ověřte si prosím důležité informace.",
    "copyText": "Zkopírovat text",
    "copied": "Zkopírováno!",
    "history": "Historie",
    "chatHistory": "Historie konverzací",
    "messages": "zpráv",
    "deleteHistory": "Smazat historii",
    "assistantIdMissing": "Assistant ID pro mód \"{{mode}}\" je prázdné nebo není nakonfigurované",
    "connectionError": "Nepodařilo se připojit k serveru."
  },
  "substitutes": {
    "validation": {
      "substitutionType": {
        "required": "Typ zastoupení je povinný"
      },
      "substituteUser": {
        "required": "Zastupující uživatel je povinný"
      },
      "absentUser": {
        "required": "Zastupovaný uživatel je povinný"
      },
      "dateFrom": {
        "required": "Datum začátku je povinné",
        "future": "Datum začátku musí být v budoucnosti"
      },
      "dateTo": {
        "required": "Datum konce je povinné",
        "future": "Datum konce musí být v budoucnosti",
        "afterDateFrom": "Datum konce musí být po datu začátku",
        "mustBeNull": "Datum konce musí být prázdné pro trvalá zastoupení"
      },
      "permanentSubstitution": {
        "onlyForSubstitution": "Trvalé zastoupení je dostupné pouze pro typ zastoupení"
      },
      "roles": {
        "required": "Alespoň jedna role musí být vybrána"
      }
    }
  },
  "agendaList": {
    "noData": "Žádné záznamy."
  },
  "notifications": {
    "action": {
      "title": "Nevyřízené úkoly",
      "subTitle": "Přehled úkolů, které vyžadují vaši pozornost.",
      "noData": "Všechny úkoly, které vyžadovaly vaši pozornost, jsou nyní úspěšně vyřízeny!"
    },
    "info": {
      "title": "Nepřečtené informace",
      "subTitle": "Přehled důležitých informací, které vyžadují vaši pozornost.",
      "noData": "Všechny důležité informace, které vyžadovaly vaši pozornost, jsou nyní úspěšně vyřízeny!"
    },
    "deleteAll": "Smazat vše",
    "deleteAllSuccess": "Všechny informativní notifikace byly smazány.",
    "filter": {
      "active": "Zobrazeny záznamy s notifikacemi",
      "clear": "Zrušit filtr notifikací"
    },
    "table": {
      "agenda": "Agenda",
      "description": "Obsah",
      "module": "Modul",
      "name": "Název úkolu"
    }
  }
}
